import { Input } from 'antd';
import PropTypes from 'prop-types';

export const BaseInput = (props) => {
  const { children, label, className, ...rest } = props;
  const customClassName = `base-input ${className}`;

  return (
    <>
      {label && <span className="base-input-label">{label}</span>}
      <Input {...rest} className={customClassName}>
        {children}
      </Input>
    </>
  );
};

BaseInput.defaultProps = {
  children: undefined,
  label: undefined,
  className: ''
};

BaseInput.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  label: PropTypes.string,
  className: PropTypes.string
};
